module.exports = __webpack_public_path__ + "submenu_index_0_active.1887c374.png";